export const MODAL_MESSAGE_NAMES = {
  SHOWN: 'MODAL_MESSAGE_NAMES__SHOWN',
  CLOSED: 'MODAL_MESSAGE_NAMES__CLOSED',
};

export const modalShown = () => ({
  type: MODAL_MESSAGE_NAMES.SHOWN,
  payload: undefined,
});

export const modalClosed = () => ({
  type: MODAL_MESSAGE_NAMES.CLOSED,
  payload: undefined,
});
